import { colors } from './colors';
import { shadows } from './shadows';

export const semanticTokens = {
	colors,
	shadows
};